import { Routes, Route, useLocation } from 'react-router-dom'; 
import './App.css';
import AdminAccueil from './pages/Accueil/Accueil';
import HeaderAdmin from './pages/Headers/header';
import AdminAnimalList from './pages/admin/adminAnimalList/adminAnimalList';
import {AdminAddEditAnimal}  from './pages/admin/adminAddEditAnimal/adminAddEditAnimal';
import { AdminReproduction } from './pages/admin/adminReproduction/adminReproduction'; 
import {UsersList} from './pages/admin/adminUserManage/usersList';
import Dash from './dash';
import SignUp from './pages/SignUp/SignUp';
import ProtectedRoute from './Contexts/ProtectedRoute';
import { DetailsAnimal } from './pages/admin/DetailsAnimal';
import {AddEditUser} from './pages/admin/adminUserManage/addEditUser';
import Header from './pages/Headers/header';
import AnimalsList from './pages/eleveur/eleveurAnimalsList/animalsList';
import Profile from './pages/eleveur/Profile/profile';
import EditReproduction from './pages/admin/adminReproduction/editReproduction';
import { EleveurReproduction } from './pages/eleveur/Reproduction/EleveurReproduction';
import { DetailsAnimalE } from './pages/eleveur/DetailsAnimalE';
import ToDoToday from './pages/eleveur/ToDoToday/toDoToday';
import ToDoTodayAdmin from './pages/admin/TodoToday/toDoTodayAdmin';
import { Croissance } from './pages/eleveur/croissance/Croissance';
import { AdminCroissance } from './pages/admin/adminCroissance/adminCroissance';
import { AdminAddEditAnimalEleveur } from './pages/eleveur/eleveurAnimalsList/addEditAnimal/adminAddEditAnimalEleveur';

import VerifyMail from './pages/SignUp/verifyMail';
import FermeEdit from './pages/admin/adminFerme/fermeEdit';
import AuthCallback from './pages/AuthCallback/AuthCallback';
import LandingPage from './pages/LandingPage/LandingPage';
import SuperAdminDashboard from './pages/superAdmin/SuperAdminDashboard';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService/TermsOfService';
import DataDeletion from './pages/DataDeletion/DataDeletion';

function App() {
  const location = useLocation();
  const hideHeaderPaths = ['/signin', '/signup', '/signin/', '/signup/', '/', '/verification', '/verification/', '/privacy', '/privacy/', '/terms', '/terms/', '/data-deletion', '/data-deletion/'];
  const isHomePage = location.pathname === '/';
  const isAuthPage = ['/signin', '/signup', '/signin/', '/signup/'].includes(location.pathname);
  const shouldShowHeader = !hideHeaderPaths.includes(location.pathname) && !isHomePage;

  return (
    <div
      className={`App${isAuthPage ? ' App--auth-mobile-offset' : ''}`}
      style={{ paddingTop: shouldShowHeader ? '80px' : 0 }}
    >
      {shouldShowHeader && <Header />}
      <Routes>
        <Route path='/signin' element={<Dash />} />
        <Route path='/' element={<LandingPage />} />
        <Route path='/signup' element={<SignUp />} />
        <Route path='/auth/callback' element={<AuthCallback />} />
        <Route path='/verification' element={<VerifyMail />} />
        <Route path='/privacy' element={<PrivacyPolicy />} />
        <Route path='/terms' element={<TermsOfService />} />
        <Route path='/data-deletion' element={<DataDeletion />} />
        <Route element={<ProtectedRoute role="superadmin"/>}>
            <Route path='/superadmin' element={<SuperAdminDashboard />}/>
        </Route>
        <Route element={<ProtectedRoute role="admin"/>}>
            <Route path='/admin/animal/details/:id' element={<DetailsAnimal />}/> 
            <Route path='/admin' element={<AdminAccueil />}/> 
          <Route path='/admin/profile' element={<Profile />}/>
            <Route path='/admin/reproduction' element={<AdminReproduction />}/> 
            <Route path='/admin/croissance' element={<AdminCroissance />}/> 
            <Route path='/admin/animals' element={<AdminAnimalList />}/> 
            <Route path='/admin/add-animal' element={<AdminAddEditAnimal />}/>
            <Route path='/admin/add-animal/:id' element={<AdminAddEditAnimal />}/>
            <Route path='/admin/manage-users' element={<UsersList />}/>
            <Route path='/admin/edit/:id' element={<AdminAddEditAnimal edit={true} />}/>
            <Route path='/admin/add-user/' element={<AddEditUser  />}/>
            <Route path='/admin/edit/user/:id' element={<AddEditUser isEdit={true} />}/>
            <Route path='/admin/reproduction/edit/:id' element={<EditReproduction />}/>
            <Route path='/admin/to-do' element={<ToDoTodayAdmin />}/>
            <Route path='/admin/edit-ferm' element={<FermeEdit />}/>
        </Route> 
        <Route element={<ProtectedRoute role="eleveur"/>}>
            <Route path='/eleveur/to-do' element={<ToDoToday />}/>
            <Route path='/eleveur' element={<AdminAccueil />}/>
            <Route path='/eleveur/profile' element={<Profile />}/>
            <Route path='/eleveur/animals' element={<AnimalsList />}/>
            <Route path='/eleveur/edit/:id' element={<AdminAddEditAnimalEleveur edit={true} />}/>
            <Route path='/eleveur/add-animal/:id' element={<AdminAddEditAnimalEleveur />}/>
            <Route path='/eleveur/add-animal/' element={<AdminAddEditAnimalEleveur />}/>
            <Route path='/eleveur/reproduction' element={<EleveurReproduction />}/>
            <Route path='/eleveur/croissance' element={<Croissance />}/>
            <Route path='/eleveur/animal/details/:id' element={<DetailsAnimalE />}/>
        </Route> 
      </Routes>
    </div>
  );
}

export default App;